import { NumberSelector } from 'app/components/form/NumberSelector'
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { isValidPerson, Profile } from 'app/redux/Profile/model'
import * as React from 'react'
import { Button } from 'react-bootstrap'

interface IRetirementInvestmentReturnsContainerState {
  rateOfReturn: number
}

class RetirementInvestmentReturnsContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, IRetirementInvestmentReturnsContainerState> {
  rateOfReturnNS = 'ratesOfReturn.default'
  profile: Profile

  state: IRetirementInvestmentReturnsContainerState = {
    rateOfReturn: this.getValueForQuestion(this.rateOfReturnNS)
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      this.profile = appState.Profile.getNative('info')
      const member = this.profile.getHeadOfHousehold()
      // nothing else here...
    })
  }

  updateRateOfReturn(rateOfReturn: number) {
    this.setState({rateOfReturn })
    this.profile.ratesOfReturn.default = rateOfReturn
    this.markSignificantProfileUpdate(this.profile)
  }

  render() {
    const assumedRateOfReturn = 4
    return (
      <section>
        <h1>Investment Returns</h1>
        <h5 className="lead">A key component of savings plans is the annual earnings on the investments held in the account.
        </h5>
        <h5 className="lead Question"><b>What average investment return are you expecting to earn each year on your combined balances from now until the point that you start withdrawals?</b></h5>
        <NumberSelector width={'330px'} cellSuffix={'%'}
          min={3} max={7} selectedValue={this.state.rateOfReturn}
          onChange={(a) => this.updateRateOfReturn(a)} />

        <h5 className="lead">While investment returns can vary from year-to-year, past market performance has given a general gauge to help us estimate what an average return over a number of years might be for a given set of investments:</h5>
        <ul>
            <li>Conservative investments (e.g., CDs, money market, bonds) seek a lower return on the investment.  In turn, they tend to see lower levels of return variation (volatility) from year-to-year.</li>
            <br/>
            <li>Aggressive investments (e.g., stocks, high-yield bonds) seek a higher return on the investment.  In turn, they tend to see higher levels of volatility from year-to-year.</li>
        </ul>
        <h5 className="lead">After withdrawals commence, the projections assume a {assumedRateOfReturn}% average annual investment return.</h5>
      </section>
    )
  }
}

const RetirementInvestmentReturns = () => (
  <RetirementInvestmentReturnsContainer
    header="Investment Returns" icon="" />
)

export {
    RetirementInvestmentReturns
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/InvestmentReturns/index.tsx